/** Actions available in each of supported state machines */
export = {
	SimpleApprove: [
		"Approve",
	],
	SimpleRevision: [
		"RevertToDraft",
		"ReviseAndAbandon",
		"|",
		"Approve",
	],
	DocumentRevision: [
		"RevertToDraft",
		"Revise",
		"|",
		"MakePending",
		"Approve",
		"CloseRevision",
	],
	DocumentRevisionConfirm: [
		"RevertToDraft",
		"Revise",
		"MassUpdateDataSheets",
		"|",
		"MakePending",
		"ApproveConfirm",
		"CloseRevision",
	],
	DocumentRevisionNoClosed: [
		"RevertToDraft",
		"Revise",
		"|",
		"MakePending",
		"Approve",
	],
	DocumentRevisionNoPending: [
		"RevertToDraft",
		"Revise",
		"|",
		"Approve",
		"CloseRevision",
	],
	DGaaSRevision: [
		"RevertToDraft",
		"|",
		"Approve",
	],
	NegotiatedDocumentRevision: [
		"RevertToDraft",
		"Revise",
		"|",
		"MakePending",
		"MakePending2",
		"Approve",
	],
	OperationsReviewRevision: [
		"RevertToDraft",
		"MakePending",
		"Approve",
	],
	OperationsReviewRevisionExpress: [
		"RevertToDraft",
		"Approve",
	],
	PhasedRevision: [
		"ReviseAndAbandon",
		"MakePending",
		"MakePending2",
		"|",
		"EndPhase",
		"|",
		"ReopenPhase",
		"Abandon",
	],
	PhasedReviewRevision: [
		"ReviewStart",
		"ReviewReopen",
		"ReviewApprove",
		"ReviewFail",
		"ReviewCancel",
		"ReviseAndAbandon",
		"MakePending",
		"MakePending2",
		"|",
		"EndPhase",
		"|",
		"ReopenPhase",
		"Abandon",
	],
	SupplierItemRevision: [
		"ReviseAndAbandon",
		"MakePending",
		"|",
		"Approve",
		"CloseRevision",
		"|",
		"ReopenPhase",
		"Abandon",
		"|",
		"CancelOffline",
	],
	FoodSupplierItemRevision: [
		"ReviseAndAbandon",
		"MakePending",
		"|",
		"Approve",
		"CloseRevision",
		"|",
		"ReopenPhase",
		"Abandon",
		"|",
		"CancelOffline",
	],
	SpecificationDataSheetSupplierResponseRevision: [
		"ReviseAndAbandon",
		"MakePending",
		"|",
		"Approve",
		"CloseRevision",
		"|",
		"ReopenPhase",
		"Abandon",
		"|",
		"CancelOffline",
	],
	AffectedSpecRevision: [
		"ReviseAndAbandon",
		"Abandon",
	],
	ProofingRevision: [
		"RevertToDraft",
		"Revise",
		"|",
		"MakePending",
		"Approve",
		"CloseRevision",
	],
	RecipeDataSheetRevision: [
		"ReviseAndAbandon",
		"MakePending",
		"|",
		"EndPhase",
		"|",
		"ReopenPhase",
		"Abandon",
	],
	SourceBOMRevision: [
		"MakePending",
		"|",
		"Approve",
		"|",
		"ReopenPhase",
		"Abandon",
	],
};
